/* cart-badge-main-items.js
   Show only REAL products (not Globo option lines) in the cart badge
--------------------------------------------------------------------*/
(() => {
  /* --- 1. Keys that identify a Globo child line ------------------ */
  const GLOBO_CHILD_KEYS = [
    "_gpo_parent_product_group", // ← present on every child
    "_gpo_field_name",
    "gpo-parent-product-group", // legacy key, just in case
    "gpo-hidden",
    "_gpo", // safety net
  ];

  /* --- 2. Helper: is this cart item a Globo child? --------------- */
  const isGloboChild = (item) =>
    item.properties &&
    GLOBO_CHILD_KEYS.some((k) =>
      Object.prototype.hasOwnProperty.call(item.properties, k)
    );

  /* --- 3. Update all <cart-count> badges ------------------------- */
  const setBadge = (count) => {
    document.querySelectorAll("cart-count").forEach((el) => {
      el.textContent = count;
      el.setAttribute(
        "aria-label",
        `${count} ${count === 1 ? "item" : "items"}`
      );
    });
  };

  /* --- 4. Pull latest cart + refresh badge ----------------------- */
  const refreshBadge = () => {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        const mainItems = cart.items.filter((item) => !isGloboChild(item));
        setBadge(mainItems.length);
      })
      .catch(() => {
        /* silent fail – don’t break the theme */
      });
  };

  /* --- 5. Run on load + whenever the cart changes ---------------- */
  document.addEventListener("DOMContentLoaded", refreshBadge);
  document.body.addEventListener("cart:updated", refreshBadge);
  document.body.addEventListener("ajaxProduct:added", refreshBadge);
})();
